import {
    Calendar,
    Clock3,
} from "lucide-react";

function OrderHistoryStats({

    totalBookings,

    totalHours,
}) {

    return (

        <div style={styles.grid}>

            <div style={styles.card}>

                <div>

                    <div style={styles.label}>
                        Total Bookings
                    </div>

                    <div style={styles.value}>
                        {totalBookings}
                    </div>

                </div>

                <Calendar
                    size={32}
                    color="#00ff88"
                />

            </div>

            <div style={styles.card}>

                <div>

                    <div style={styles.label}>
                        Total Hours
                    </div>

                    <div style={styles.value}>
                        {totalHours}h
                    </div>

                </div>

                <Clock3
                    size={32}
                    color="#00d4ff"
                />

            </div>

        </div>
    );
}

const styles = {

    grid: {

        display: "grid",

        gridTemplateColumns:
            "repeat(auto-fit,minmax(260px,1fr))",

        gap: "20px",

        marginBottom: "30px",
    },

    card: {

        background:
            "rgba(0,40,70,0.75)",

        border:
            "1px solid rgba(0,255,136,0.15)",

        borderRadius: "24px",

        padding: "24px",

        display: "flex",

        justifyContent:
            "space-between",

        alignItems: "center",

        backdropFilter:
            "blur(10px)",
    },

    label: {

        color: "#9ca3af",

        marginBottom: "8px",
    },

    value: {

        color: "#fff",

        fontSize: "34px",

        fontWeight: "800",
    },
};

export default OrderHistoryStats;